module.exports = __webpack_public_path__ + "img/confirm-active.d3c0dd4a.svg";